export default "__VITE_ASSET__aa03f3f3__"